export default "__VITE_ASSET__SLPD8YvA__"